var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-network-1{fill:#669df6;fill-rule:evenodd;}.cls-network-2{fill:#4285f4;}.cls-network-3{fill:#aecbfa;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_Network_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-network-1",
    points: "4.94 13.7 11.53 20.22 12.62 19.07 6.3 12.93 4.94 13.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-network-1",
    points: "12.57 4.06 11.48 5.22 17.69 11.44 19.47 11.06 12.57 4.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-network-2",
    x: 11.38,
    y: 5.13,
    width: 1.25,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-network-2",
    x: 11.38,
    y: 14.5,
    width: 1.25,
    height: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-network-3",
    cx: 12,
    cy: 4.5,
    r: 1.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-network-3",
    cx: 12,
    cy: 19.5,
    r: 1.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-network-1",
    points: "2.66 11.38 17.73 11.38 21.37 13.25 6.3 13.25 2.66 11.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-network-3",
    cx: 4.5,
    cy: 12.31,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-network-3",
    cx: 19.5,
    cy: 12.31,
    r: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.06a2d8515c6bbd816c2e79e9336066d8.svg";
export { ForwardRef as ReactComponent };